import type { GlobalEvent, WorldData } from "../../domain/types";
import { formatScope, formatScopeType, formatSeverity } from "../format";


export function EventList({ events, emptyText, world }: { events: GlobalEvent[]; emptyText: string; world?: WorldData }) {
  return (
    <ul className="event-list">
      {events.length === 0 && <li>{emptyText}</li>}
      {events.slice(0, 8).map((event) => (
        <li key={event.id}>
          <span className={`severity ${event.severity}`}>{formatSeverity(event.severity)}</span>
          <strong>{event.title}</strong>
          <em>{eventScopeLabel(world, event)}</em>
        </li>
      ))}
    </ul>
  );
}

function eventScopeLabel(world: WorldData | undefined, event: GlobalEvent): string {
  if (world) {
    return formatScope(world, event.scopeType, event.scopeValue);
  }
  return `${formatScopeType(event.scopeType)}：${event.scopeValue}`;
}
